import { icons } from "../../constants";
import { formatCustomDateIsoString } from "../../services/dateService";
import { import_registration } from "../../constants/enums";

export const getCurrent = (statusCode) => {
  const stateStyles = {
    [import_registration.CURRENT]: {
      label: "Vigente",
      bg: "#E8F5E9",
      color: "#1B5E20"
    },
    [import_registration.NOT_CURRENT]: {
      label: "No vigente",
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    [import_registration.EXPIRED]: {
      label: "Vencido",
      bg: "#FFF3E0",
      color: "#E65100"
    },
    [import_registration.DELETED]: {
      label: "Eliminado",
      bg: "#FFEBEE",
      color: "#B71C1C"
    }
  };

  const meta = stateStyles[statusCode];
  if (!meta) return null;

  const pillStyle = {
    padding: "8px 12px",
    fontSize: 12,
    lineHeight: 1,
    borderRadius: 999,
    backgroundColor: meta.bg,
    color: meta.color,
    fontWeight: 600,
    width: "85px",
    textAlign: "center"
  };

  return <span style={pillStyle}>{meta.label}</span>;
};

export const foreign_trade_import_registration_TABLE = (
  navigate,
  handleOpenModal,
  onDeleteRow
) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;

  return [
    { field: "registration_number", header: "Nro de Registro" },
    { field: "supplier_name", header: "Proveedor" },
    { field: "product", header: "Producto" },
    {
      field: "start_date",
      header: "Fecha Inicio Vigencia",

      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDateIsoString(String(rowData.start_date))}
        </p>
      )
    },
    {
      field: "end_date",
      header: "Fecha Fin Vigencia",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDateIsoString(String(rowData.end_date))}
        </p>
      )
    },
    {
      field: "state",
      header: "Vigente",
      columnType: "custom",
      render: (rowData) => (
        <p className="j-center">{getCurrent(rowData.state)}</p>
      )
    },
    {
      field: "request_date",
      header: "Solicitud de emision o renovacion",

      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDateIsoString(String(rowData.request_date))}
        </p>
      )
    },
    {
      field: "actionButtons",
      header: "",
      columnType: "custom",
      render: (rowData) => {
        const rowState = Number(rowData.state);
        const isEditVisible =
          rowState === import_registration.CURRENT ||
          rowState === import_registration.EXPIRED;
        const hasFile = rowData.file_path && String(rowData.file_path).trim();

        return (
          <div className={`IHContainer `}>
            {isEditVisible && (
              <div className="eye-btn" onClick={() => handleOpenModal(rowData)}>
                <img
                  className="btn-icon-table"
                  src={icons.update_register}
                  alt="icon"
                />
              </div>
            )}

            {onDeleteRow && (
              <div
                className="eye-btn"
                onClick={() => onDeleteRow(rowData)}
                title="Eliminar"
              >
                <img
                  className="btn-icon-table"
                  src={icons.redTrash}
                  alt="eliminar"
                />
              </div>
            )}

            {hasFile ? (
              <div
                className="eye-btn"
                onClick={() => {
                  const path = rowData.file_path;
                  const fileUrl = `${apiBaseUrl}/${path}`.replace(/([^:]\/)\/+/g, "$1");
                  window.open(fileUrl, "_blank");
                }}
              >
                <img className="btn-icon-15" src={icons.linkBlue} alt="icon" />
              </div>
            ) : null}
          </div>
        );
      }
    }
  ];
};
